<template>
    <rkm-layout-body title="Lista de grupos">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-grupo-create' })"
                color="primary"
                authorize="store-cadastro-grupo"
            >
                Cadastrar grupo
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/grupo/List'

export default {
    components: { List },
}
</script>